<template>
  <md-dialog @md-clicked-outside="$emit('close')" :md-active.sync="showDialog">
    <md-dialog-content :style="modalContainerStyle">
      <md-button class="md-icon-button" v-if="showBackBtn" @click="$emit('back')">
        <md-icon translate="no"> arrow_back </md-icon>
        <md-tooltip>Back</md-tooltip>
      </md-button>
      <md-button v-if="showCloseBtn" class="md-accent md-right md-icon-button" @click="$emit('close')">
        <md-icon translate="no"> close </md-icon>
      </md-button>
      <main>
        <slot name="modalContent"></slot>
      </main>
    </md-dialog-content>
    <md-dialog-actions>
      <slot name="dialog-actions"></slot>

      <md-button v-if="showSaveBtn" class="md-primary" @click="$emit('save')">Save</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
export default {
  name: "Modal",
  props: {
    showSaveBtn: Boolean,
    showBackBtn: Boolean,
    showCloseBtn: {
      type: Boolean,
      default: true,
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    modalContainerStyle: {
      type: Object,
      default: () => Object.assign({}),
    },
  },
};
</script>

<style lang="css" scoped>
.md-dialog /deep/.md-dialog-container {
  /* max-width: 950px; */
}

.md-right {
  position: absolute !important;
  right: 0 !important;
  top: 0 !important;
}
</style>
